import React from 'react';
import Section from '../components/section/Section';

const index = () => {
    return (
        <div className="relative w-full h-full">
            <Section/>
            
        </div>
    );
};

export default index;